// MARK: NPM Modules
import React from "react";
import styled from "styled-components";
// MARK: Styled Components
const IFrame = styled(({ marginTop, height, ...props }) => (
  <iframe {...props} />
))`
  width: 100%;
  height: 60vw;
  border: none;
  padding: 0;
  margin: 0;
`;
// MARK: React Components
// Props
interface MediaProps {
  title: string;
  src: string;
}
// Component
const OnlineVideo = ({ title, src }: MediaProps) => {
  return <IFrame title={title} src={src} loading="lazy" />;
};

export default OnlineVideo;
